import React from 'react';
import Icon from '../../../components/AppIcon';

const BrandingSection = ({ language }) => {
  const translations = {
    en: {
      welcome: 'Welcome to',
      platform: 'Africoffee Admin',
      tagline: 'Manage your African coffee bean trading platform',
      description: 'Access comprehensive tools to manage suppliers, products, orders, and translations. Monitor farm data, process customer requests, and maintain the quality standards that make Africoffee the trusted platform for African green coffee bean trading.',
      stats: [
        { value: '4', label: 'Countries' },
        { value: '8+', label: 'Coffee Varieties' },
        { value: '100%', label: 'Verified Suppliers' }
      ]
    },
    zh: {
      welcome: '欢迎来到',
      platform: 'Africoffee 管理',
      tagline: '管理您的非洲咖啡豆交易平台',
      description: '访问综合工具来管理供应商、产品、订单和翻译。监控农场数据，处理客户请求，并维护使Africoffee成为非洲绿咖啡豆交易可信平台的质量标准。',
      stats: [
        { value: '4', label: '国家' },
        { value: '8+', label: '咖啡品种' },
        { value: '100%', label: '认证供应商' }
      ]
    }
  };

  const t = translations?.[language];

  return (
    <div className="w-full max-w-md">
      <div className="mb-8">
        <p className="text-sm text-muted-foreground mb-2">
          {t?.welcome}
        </p>
        <h1 className="text-4xl font-heading font-bold text-foreground mb-3">
          {t?.platform}
        </h1>
        <p className="text-lg text-primary font-medium mb-6">
          {t?.tagline}
        </p>
        <p className="text-sm text-muted-foreground leading-relaxed">
          {t?.description}
        </p>
      </div>
      <div className="grid grid-cols-3 gap-4">
        {t?.stats?.map((stat, index) => (
          <div key={index} className="bg-card rounded-lg border border-border p-4 text-center">
            <div className="text-2xl font-heading font-bold text-primary mb-1">
              {stat?.value}
            </div>
            <div className="text-xs text-muted-foreground">
              {stat?.label}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-8 bg-primary/5 rounded-lg border border-primary/10 p-4">
        <div className="flex items-start gap-3">
          <Icon name="Coffee" size={24} color="var(--color-primary)" className="flex-shrink-0" />
          <div className="flex-1">
            <p className="text-sm text-foreground leading-relaxed">
              {language === 'en' ?'Connecting African coffee excellence with global markets through verified quality and transparent sourcing.' :'通过经过验证的质量和透明的采购，将非洲咖啡卓越品质与全球市场连接起来。'
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandingSection;